<template>
  <v-container>
    <v-navigation-drawer v-model="drawer" fixed clipped app>
      <v-list class="pa-1">
        <v-list-tile avatar>
          <v-list-tile-avatar :color="Auth.userData.color">
            <span
              class="white--text title"
            >{{ Auth.userData.name[0] }}{{ Auth.userData.surname[0] }}</span>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ Auth.userData.name }} {{ Auth.userData.surname }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ Auth.userData.title }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn flat icon color="secondary" to="/user/edit" router>
              <v-icon>edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <template v-for="(item, i) in items">
          <v-divider v-if="item.divider" :key="i" light></v-divider>
          <v-subheader v-else-if="item.subheader" :key="i">{{ item.subheader }}</v-subheader>
          <v-list-tile v-else-if="item.logout" :key="i" @click="logout">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-else-if="item.change && !item.disabled"
            :key="i"
            @click="showChangeDialog()"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-else-if="!item.disabled" :key="i" :to="item.url" router>
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" fixed dark app :clipped-left="$vuetify.breakpoint.lgAndUp">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>PI System</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>chat</v-icon>
      </v-btn>-->
    </v-toolbar>
    <!-- <router-view /> -->
    <v-fade-transition mode="out-in">
      <router-view :key="$route.fullPath"/>
    </v-fade-transition>
    <pi-dialog
      :dialog="changeDialog.on"
      :progress="changeDialog.progress"
      headline="Zmiana systemu"
      operation="Zmień"
      @closed="showChangeDialog(false)"
      @action="changeSystem()"
    >
      <v-select
        v-model="changeDialog.project"
        :items="changeDialog.projects"
        item-text="fullName"
        item-value="shortName"
        prepend-icon="developer_board"
        label="System"
      ></v-select>
    </pi-dialog>
    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    drawer: true,
    items: [
      { divider: true },
      { subheader: "System" },
      { title: "Dashboard", icon: "dashboard", url: "/" },
      { title: "Użytkownicy", icon: "contacts", url: "/user/all" },
      { title: "Grupy", icon: "group", url: "/group/all" },
      { title: "Repozytorium", icon: "storage", url: "/filetree" },
      { title: "Harmonogram", icon: "event", url: "/schedule" },
      {
        title: "Zmień system",
        icon: "developer_board",
        change: true,
        disabled: true
      },
      // { title: 'Zgłoś błąd', icon: 'feedback' },
      { title: "Wyloguj", icon: "lock", logout: true }
      // { subheader: 'Biuro' },
      // { title: 'Projekty', icon: 'list' },
      // { title: 'Dokumentacja przychodząca', icon: 'book' },
      // { title: 'Dokumentacja wychodząca', icon: 'book' },
      // { title: 'Umowy', icon: 'library_books' },
      // { title: 'Faktury przychodzące', icon: 'receipt' },
      // { title: 'Faktury wychodzące', icon: 'receipt' },
      // { title: 'Rachunki', icon: 'description' },
      // { title: 'Delegacje', icon: 'airplanemode_active' },
      // { subheader: "Repozytorium" },
      // { title: "Pliki", icon: "storage" },
      // { title: "Uprawnienia", icon: "assignment_ind" }
      // { title: 'Aplikacja synchronizująca', icon: 'apps' },
      // { subheader: 'Terminarz' },
      // { title: 'Plan projektu', icon: 'map' },
      // { title: 'Wydarzenia', icon: 'event' },
    ],
    changeDialog: {
      on: false,
      progress: false,
      project: "",
      projects: []
    },
    snackbar: { on: false, color: "error", message: "" }
  }),
  methods: {
    async showChangeDialog(show = true) {
      this.changeDialog.on = show;
    },
    async changeSystem() {
      this.changeDialog.progress = true;
      const response = await this.Api.send("post", `/auth/changeSystem`);
      this.changeDialog.progress = false;
      if (response.status) {
        const project = this.changeDialog.projects.find(
          p => p.shortName == this.changeDialog.project
        );
        const protocol = project.ssl ? "https" : "http";
        window.location = `${protocol}://${project.domain}/change/${
          response.hash
        }`;
      }
      this.showChangeDialog(false);
      this.snackbar.message = response.message;
      this.snackbar.on = true;
    },
    logout() {
      this.$router.push({ path: "/logout" });
    }
  },
  async mounted() {
    if (!this.Auth.avaibleProjects || this.Auth.avaibleProjects.lenght < 2)
      return;
    this.items.find(i => i.change).disabled = false;
    this.changeDialog.project = this.Auth.avaibleProjects.find(
      p => p.current
    ).shortName;
    this.changeDialog.projects = this.Auth.avaibleProjects.filter(
      p => !p.current
    );
  }
};
</script>

<style>
.content--wrap {
  position: relative;
}
</style>
